import { ColumnDef, ModelDef } from '@shared/model'
import { AxE2ConfigModelDef } from '../services/$AxE2Config'
import { $axAuthState } from '../services/$axAuthStateManager'
import { $toast } from '../services/$toast'
import { $appHook } from '@shared/model/$appHook'
import { $AxE2AppHooks } from '../services/$AxE2AppHooks'
import { $Redirecter } from '@/services/redirecter'
import { cecPaths } from '@/cecSitePath'
import { getFormatPhone } from '../utils/phoneFormat'

interface Columns {
  [colName: string]: ColumnDef
}

// パスワードチェック
export const passwordValidator = (value) => {
  const low_case = /[a-z]/
  const upper_case = /[A-Z]/
  const number = /[0-9]/
  const isValid =
  low_case.test(value) && upper_case.test(value) && number.test(value) && value.length >= 8 && value.length <= 32
  if (!isValid) {
    return '8文字以上32文字以下の半角英大文字、小文字、数字混在、それぞれ必ず1文字を入れて入力してください。'
  }
  return
}

//　数字であるかチェック
export const is_int = (value,name) => {
  const int = /[0-9]/
  const isValid = int.test(value)
  if(!isValid){
    return name + 'を正しく入力してください'
  }
}

// 入力した値が空かチェック
export const isNotEmpty = (value) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return '入力必須です'
  }
}

// メール形式チェック
export const is_email = (value,name) => {
  if(!value.match("^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$")){
    return name + 'の形式で入力してください'
  }
}

// 選択がないかチェック
export const isNotEmptySelect = (value,name) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return name + 'を選択してください'
  }
}

export const userColumns: Columns = {
  email: {
    type: 'STRING',
    label: 'メールアドレス',
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 280px;' },
    validate: { is_email,isNotEmpty},
  },

  birthday_y: {
    type: 'STRING',
    label: '生年月日 (年)',
    validate: { isNotEmpty },
    strictSelections: true,
    selections: () => {
      const yearCounts = 110
      const years = []
      const currentYear = new Date().getFullYear()
      for (let i = 0; yearCounts >= i; i++) {
        years.push(currentYear - (yearCounts - i))
      }
      return years
    },
    default_select_scroll_to_value: 2000,
  },

  birthday_m: {
    type: 'STRING',
    label: '生年月日 (月)',
    validate: { isNotEmpty },
    strictSelections: true,
    selections: () => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    inputHelpText: '月',
  },

  birthday_d: {
    type: 'STRING',
    label: '生年月日 (日)',
    validate: { isNotEmpty },
    strictSelections: true,
    selections: () => {
      const counts = 31
      const days = []
      for (let i = 1; counts >= i; i++) {
        days.push(i)
      }
      return days
    },
    inputHelpText: '日',
  },
  tel_primary: {
    type: 'STRING',
    label: '電話番号',
    validate: { is_int,isNotEmpty},
    enableIf: (row) => !row.token,
  },
  password: {
    type: 'STRING',
    label: 'パスワード',
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 280px;', type: 'password' },
    validate: {
      isNotEmpty,
      passwordValidator
    },
  },
  password_confirm: {
    type: 'STRING',
    label: 'パスワード (確認)',
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 280px;', type: 'password' },
    validate: {
      isNotEmpty,
      passwordValidator,
      sameWithPassword: (password_confirm, password) => {
        if(!passwordValidator(password_confirm)){
           // パスワード同じかどうか
          if (password_confirm && password_confirm !== password) {
            return '確認入力が合致しません'
          }
        }
        return false
      },
    },
  },
}



export const executeRequestPasswordReset = async (data, useDefaultMessage = true) => {
  try {
    const isRequestToken = !!data.token
    if (isRequestToken) {
      const user: any = {}
      for (const key of Object.keys(data)) {
        // token以外はuserのオブジェクトの中にいれる
        if (key !== 'token') {
          user[key] = data[key]
          delete data[key]
        }
      }
      delete data['password_confirm']
      data.user = user
    } else {
      data.user = { email: data.email }
      if(data.birthday_y && data.birthday_m && data.birthday_d){
          data.user.birthday = `${data.birthday_y}-${data.birthday_m
          .toString()
          .padStart(2, '0')}-${data.birthday_d.toString().padStart(2, '0')}`
      }else if(data.tel_primary){
          if(data.tel_primary.match("-")){
            data.user.tel_primary = data.tel_primary
          }else{
            const tel_primary = getFormatPhone(data.tel_primary)
            data.user.tel_primary = tel_primary
          }
      }else{
        throw new Error('エラーが発生しました。再度お試しください。')
      }
    }
    await $axAuthState.passwordReset(data)
    if (useDefaultMessage) {
      if (isRequestToken) {
        // 自動でログイン画面へリダイレクトする
        // $Redirecter.openSite(cecPaths.accounts.login, false)
      } else {
      }
      if ($appHook.hasHook($AxE2AppHooks.passwordResetAfter)) {
        $appHook.callHooks($AxE2AppHooks.passwordResetAfter, null, this)
      }
    }
    return true
  } catch (e) {
    if ($appHook.hasHook($AxE2AppHooks.passwordReset.ERROR)) {
      await $appHook.callHooks($AxE2AppHooks.passwordReset.ERROR, e)
    } else {
       throw new Error('エラーが発生しました。再度お試しください。')
    }
    return false
  }
}

export const passwordReset: ModelDef & AxE2ConfigModelDef<any> = {
  tableName: 'password',
  tableLabel: 'パスワード再設定',
  defaultSort: { key: 'createdAt', order: 'desc' },
  timestamps: false,
  columns: userColumns,
  onSubmitFunction: executeRequestPasswordReset,
}

/*
    バリデーション処理
*/
export const validate = (data,errors) => {
  const colDef = userColumns
  const colData = data
  errors.flag = false
  for(const keyname in colData){
    errors[keyname] = {}
    if(colDef[keyname] && colDef[keyname].validate){
        let error = []
        // カスタムカラム名なしのバリデーション
        Object.keys(colDef[keyname].validate).map((key) => {
          let errormessage = '';
          const labelname = colDef[keyname].label
          // パスワード再設定のエラーチェック処理
          if(keyname === 'password' || keyname === 'password_confirm'){
            if(key === 'sameWithPassword'){
              // パスワードが不一致の場合に処理
              errormessage = colDef[keyname].validate[key](colData[keyname],colData['password'])
            }else{
              errormessage = colDef[keyname].validate[key](colData[keyname],labelname)
            }
          }else{
            // パスワード忘れた方のエラーチェック処理
            errormessage = colDef[keyname].validate[key](colData[keyname],labelname)


            // 誕生日が入っている場合はエラーメッセージ(電話)を消去
            if(keyname === 'birthday_y' || keyname === 'birthday_m' || keyname === 'birthday_d'){
              if(colData['tel_primary']){
                errormessage = ''
              }
            }

            // 電話番号が入っている場合はエラーメッセージ(誕生日)を消去
            if(keyname === 'tel_primary'){
              if(colData['birthday_y'] && colData['birthday_m'] && colData['birthday_d']){
                errormessage = ''
              }
            }
          }

          // エラーメッセージが入っている場合はエラー内容を追加する
          if(errormessage){
            error.push(errormessage)
            // debug
            // console.log(`エラー: ${keyname} => `+ labelname + ':' + errormessage)
          }
        })

        if(error.length !== 0){
          errors[keyname].message = error.join(',')
          // 各カラムのエラー有効
          errors[keyname].flag = true
          // 全カラムのエラー有効
          errors.flag = true
        }
    }
  }
}
